/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Teamskills1Inputs */

const en_entity_teamskills1 = /** @type {(inputs: Entity_Teamskills1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Skills`)
};

const de_entity_teamskills1 = /** @type {(inputs: Entity_Teamskills1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills`)
};

/**
* | output |
* | --- |
* | "Team Skills" |
*
* @param {Entity_Teamskills1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_teamskills1 = /** @type {((inputs?: Entity_Teamskills1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Teamskills1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_teamskills1(inputs)
	return de_entity_teamskills1(inputs)
});
export { entity_teamskills1 as "entity_teamSkills" }